import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import {
    useIsPlatformJourneyEnabled,
    setIsSubscribedToNewsletter,
} from '@pegasus/platform-journeys';
import { useConfig } from '@browsing/config';

import { getCookie } from '@client/helpers/cookie';
import { jsonPut } from '@client/lib/request';

const PLATFORM_JOURNEY_FEATURE = 'platform_journey';
const PLATFORM_JOURNEY_FEATURE_COOKIE = 'zl_platform_journey';

// TODO: Consider exporting it from PJ module directly.
export const HIDE_NEWSLETTER_SUBSCRIPTION_DIALOG_COOKIE_NAME = 'hide_nlsd';

export const useIsPlatformJourneyFeatureEnabled = () => {
    const config = useConfig();

    return useMemo(() => {
        const isFeatureEnabled = config.isEnabled(PLATFORM_JOURNEY_FEATURE);
        const isFeatureCookieEnabled = getCookie(PLATFORM_JOURNEY_FEATURE_COOKIE) === 'true';

        return isFeatureEnabled || isFeatureCookieEnabled;
    }, [config]);
};

export const useIsPlatformJourney = () => {
    const isPlatformJourneyEnabled = useIsPlatformJourneyEnabled();
    const isPlatformJourneyFeatureEnabled = useIsPlatformJourneyFeatureEnabled();

    return isPlatformJourneyFeatureEnabled && isPlatformJourneyEnabled;
};

export async function subscribeToNewsletter() {
    const url = '/api/phoenix/customer/onboarding';

    return jsonPut(url, {
        newsletter: true,
        type: 'PLATFORM_JOURNEY_INFORMATIONAL',
    });
}

export function useSubscribeToNewsletter() {
    const dispatch = useDispatch();

    return () => {
        dispatch(setIsSubscribedToNewsletter());

        return subscribeToNewsletter();
    };
}
